export default __webpack_public_path__ + "static/media/thum7.f7e05e89.jpg";